import { render, staticRenderFns } from "./addChannelPopup.vue?vue&type=template&id=ce45a3c2&scoped=true"
import script from "./addChannelPopup.vue?vue&type=script&lang=js"
export * from "./addChannelPopup.vue?vue&type=script&lang=js"
import style0 from "./addChannelPopup.vue?vue&type=style&index=0&id=ce45a3c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce45a3c2",
  null
  
)

export default component.exports